import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import moment from "moment";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import PaxPart from "../PaxPart/PaxPart";
import TitleCalendarPart from "../TitleCalendarPart/TitleCalendarPart";
import classnames from "classnames";
import ElementQuery from "react-element-query";
import { defaultPac, DATES_MOMENT_FORMAT } from "../common/constants.js";
import { preparePax } from "../common/utils.js";
import { END_DATE } from "react-dates/constants";
import { getCurrentScreenType } from "../../utils/dom.helpers";
import { screenSize } from "../common/constants";

//import '../thirdParty/bootstrap/css/bootstrap.css';
import css from "./styles.less";
import "../themes/default.less";

class SearchBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeRoomNum: this.props.activeRoomNum,
			pax: this.props.pax,
			promoCode: this.props.promoCode,
			selectedOption: this.props.selectedOption,
			notValidCalendarSelection: false,
			notValidOptionSelection: false,
			checkinDate: this.props.checkinDate,
			checkoutDate: this.props.checkoutDate,
			focusedInput: null,
			lockPromocode: false,
			isMobileView: false
		};

		window.addEventListener("resize", this.updateMobileViewFlag.bind(this));

	}

	componentWillReceiveProps(nextProps) {
		const { pax, checkinDate, checkoutDate, selectedOption } = nextProps;
		const nextSelectedOption = selectedOption && {
			...this.state.selectedOption,
			...selectedOption
		};
		const oldPax = this.state.pax;

		let nextState = {
			checkinDate,
			checkoutDate
		};

		if (pax.length > 0) nextState.pax = [...pax];

		if (oldPax.length > 0) nextState.pax = [...oldPax];

		if (nextSelectedOption) nextState.selectedOption = nextSelectedOption;

		if (nextSelectedOption && nextSelectedOption.optionType != "Hotel")
			nextState.lockPromocode = true;

		this.setState(nextState);
	}

	componentDidMount() {
		this.updateMobileViewFlag();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateMobileViewFlag.bind(this));
	}

	updateMobileViewFlag = () => {
		const { isMobileView: oldFlagValue } = this.state;
		const currScreenSize = getCurrentScreenType();
		const newFlagValue = currScreenSize <= screenSize.MOBILE;
		if (newFlagValue !== oldFlagValue) {
			const newState = { isMobileView: newFlagValue };
			this.setState(newState);
		}
	};

	loadSearchBox = () => {
		this.props.requestHotelsRegionsAndDates &&
			this.props.requestHotelsRegionsAndDates();
	};

	/* ---- Pax Rooms Methods ---- */

	handleAddRoom = () => {
		const { numRooms, onClickAddRoom } = this.props;
		const { pax, activeRoomNum } = this.state;
		const newDefaultPac = { ...defaultPac };

		if (pax.length < numRooms) {
			// check number of rooms limit
			let newPax = preparePax([...pax, newDefaultPac]);
			const newState = {
				...this.state,
				activeRoomNum: newPax.length > numRooms ? activeRoomNum : newPax.length,
				pax: newPax
			};

			this.setState(newState, () => {
				onClickAddRoom(this.state.pax);
				//this.changeActiveRoomNumber(this.state.activeRoomNum);
			});
		}
	};

	handleRemoveRoom = roomNumber => {
		const { onClickRemoveRoom } = this.props;
		const { pax, activeRoomNum } = this.state;
		const immutablePax = [...pax].filter((p, i) => i != roomNumber - 1);
		const newPax = preparePax(immutablePax);
		const newActiveRoomNum =
			activeRoomNum > newPax.length - 1 ? 1 : activeRoomNum;
		const newState = {
			...this.state,
			activeRoomNum: newActiveRoomNum,
			pax: newPax
		};

		this.setState(newState, () => {
			onClickRemoveRoom(this.state.pax);
		});
	};

	changeActiveRoomNumber = val => {
		const activeRoomNum = val.roomNum;
		this.setState({ activeRoomNum }, () => {
			this.props.onChangeActiveRoom(this.state.activeRoomNum);
		});
	};

	/* ---- Pax combination methods ----*/

	sortPaxByRoom = (roomA, roomB) => {
		if (roomA.roomNum === roomB.roomNum) return 0;
		if (roomA.roomNum < roomB.roomNum) return -1;
		else return 1;
	};

	handlePaxAction = (currentPax, objKey, objValue, computeFunc) => {
		if (typeof computeFunc == "function") {
			const { onChangePax } = this.props;
			const { pax } = this.state;

			const newPax = pax.find(p => p.roomNum == currentPax.roomNum);
			let temp = { ...newPax, ...currentPax };
			temp[objKey] = computeFunc(objValue);
			temp.roomNum = currentPax.roomNum;
			temp.key = objKey;
			if (this.shouldUpdatePax(temp)) {
				const nextPax = { ...currentPax, [objKey]: temp[objKey] };
				const filteredPax = pax.filter(p => p.roomNum != currentPax.roomNum);
				const newArr = [...filteredPax, nextPax].sort(this.sortPaxByRoom);
				const newState = { ...this.state, pax: newArr };

				this.setState(newState);
				onChangePax(nextPax);
			}
		}
	};

	shouldUpdatePax = newPax => {
		const { pax, numAdults, numChildren, numInfants } = this.props;
		const lookupTable = { numAdults, numChildren, numInfants };
		const newPaxVal = newPax[newPax.key];
		const maxPaxVal = lookupTable[`num${newPax.key}`];
		const newPaxIndex = newPax.roomNum - 1;
		if (newPaxVal > maxPaxVal || newPaxVal < 0) {
			return false;
		} else if (newPax.key == "Adults" || newPax.key == "Children") {
			return newPax.Children + newPax.Adults > 0;
		} else {
			return true;
		}
	};

	/* ---- Region Methods ----*/

	onChangeHotelsRegions = selectedOption => {
		this.setState({
			selectedOption,
			checkinDate: null,
			checkoutDate: null,
			notValidOptionSelection: false,
			lockPromocode: selectedOption && selectedOption.optionType != "Hotel",
			promoCode:
				selectedOption && selectedOption.optionType != "Hotel"
					? ""
					: this.state.promoCode
		});

		this.props.onChangeHotelsRegions(selectedOption);

		//this.props.resetCheckoutAvailibility();
	};

	/* ---- Advanced Methods ---- */

	onChangePromoCode = val => {
		const { onChangePromoCode } = this.props;

		this.setState({ promoCode: val });
		this.props.onChangePromoCode(val);
	};

	onFocusChange = focusedInput => {
		this.setState({ focusedInput });
	};

	/* ---- Calendar methods ---- */
	onChangeCheckinDate = startDate => {
		//inner function to call setHotelAvailability with relavent parameters
		const setCheckoutHotelAvailability = () => {
			const { selectedOption } = this.state;
			if (
				typeof selectedOption != "undefined" &&
				selectedOption.optionType == "Hotel"
			) {
				this.props.setHotelAvailability({
					forDate: startDate,
					isInit: false,
					isCheckOut: true
				});
			}
			this.setState({ focusedInput: END_DATE });
		};
		const nextState = {
			...this.state,
			checkinDate: startDate,
			checkoutDate: null,
			notValidCalendarSelection: false
		};

		this.setState(nextState, () => {
			this.props.onChangeCheckinDate(startDate);
			setCheckoutHotelAvailability();
		});
	};

	onChangeCheckoutDate = endDate => {
		const nextState = {
			...this.state,
			checkoutDate: endDate,
			focusedInput: null
		};

		this.setState(nextState, () => {
			this.props.onChangeCheckoutDate(endDate);
		});
	};

	// summery: handler to react to next or prev month click,
	// each month forward/backward will request one more month of availibility (same direction).
	// params:
	// currentDisplayDate = comes from airbnb src compmonent,
	// moment for the current displayed month in the range selector ( the left one ).
	onNextMonthClick = currentDisplayDate => {
		const { selectedOption } = this.state;
		if (
			typeof selectedOption != "undefined" &&
			selectedOption.optionType == "Hotel"
		)
			this.props.onNextMonthClick(currentDisplayDate);
	};

	onPrevMonthClick = currentDisplayDate => {
		const { selectedOption } = this.state;
		if (
			typeof selectedOption != "undefined" &&
			selectedOption.optionType == "Hotel"
		)
			this.props.onPrevMonthClick(currentDisplayDate);
	};

	/* ---- Submit  ---- */
	onClickSendSubmitSearchBox = () => {
		const { checkinDate, checkoutDate, selectedOption } = this.state;

		const { enabledRegionSelection } = this.props;

		let notValidCalendarSelectionTEMP = false;
		let notValidOptionSelectionTEMP = false;

		if (!checkinDate || !checkoutDate) {
			notValidCalendarSelectionTEMP = true;
		}
		if (enabledRegionSelection && !selectedOption) {
			notValidOptionSelectionTEMP = true;
		}

		if (notValidCalendarSelectionTEMP || notValidOptionSelectionTEMP) {
			this.setState({
				notValidOptionSelection: notValidOptionSelectionTEMP,
				notValidCalendarSelection: notValidCalendarSelectionTEMP
			});
			return false;
		}

		// strip out and hide internal state info from callback
		const {
			notValidOptionSelection,
			notValidCalendarSelection,
			activeRoomNum,
			...forExternalState
		} = this.state;
		this.props.onClickSendSubmitSearchBox(forExternalState);
	};

	render() {
		const {
			ages,
			showPaxAges,
			numRooms,
			checkinAvailability,
			checkoutAvailability,
			openAllDates,
			availabilityLoading,
			calendarOpenDirection,
			style,
			showChildren,
			showInfants,
			numInfants,
			numChildren,
			numAdults,
			lang,
			direction,
			titles,
			isRounded,
			LoginLink,
			searchOptions,
			enablePromoCode,
			displayDateFormat,
			enableTitle,
			enableAgentLogin,
			enabledRegionSelection,
			offlineAvailability
		} = this.props;

		const {
			pax,
			activeRoomNum,
			promoCode,
			selectedOption,
			checkinDate,
			checkoutDate,
			focusedInput,
			notValidCalendarSelection,
			notValidOptionSelection,
			isMobileView
		} = this.state;

		// should submit button be enabled
		const enableSubmitByOptionSelection =
			!enabledRegionSelection || (enabledRegionSelection && selectedOption);
		const enableSubmitByDateSelection = checkinDate && checkoutDate;
		const enableSubmitButton =
			enableSubmitByDateSelection && enableSubmitByOptionSelection;

		return (
			<ElementQuery
				sizes={[
					{ name: "width-xs", width: 1 },
					{ name: "width-sm", width: 768 },
					{ name: "width-md", width: 992 },
					{ name: "width-lg", width: 1200 }
				]}
			>
				<div
					style={style}
					className={classnames(css.searchBox, css[direction], "sbox-main")}
					id="silverSearchBox"
				>
					<div
						className={classnames(
							css.part,
							css.first,
							"sbox-col-xs-12",
							"sbox-col-sm-6"
						)}
					>
						<div className={css.inside}>
							<TitleCalendarPart
								offlineAvailability={offlineAvailability}
								calendarOpenDirection={calendarOpenDirection}
								checkoutAvailability={checkoutAvailability}
								checkinAvailability={checkinAvailability}
								availabilityLoading={availabilityLoading}
								lang={lang}
								displayDateFormat={displayDateFormat}
								notValidRegion={notValidOptionSelection}
								notValidCalendar={notValidCalendarSelection}
								checkinDate={checkinDate}
								checkoutDate={checkoutDate}
								openAllDates={openAllDates}
								focusedInput={focusedInput}
								direction={direction}
								enableTitle={enableTitle}
								enablePromoCode={enablePromoCode}
								enableAgentLogin={enableAgentLogin}
								enabledRegionSelection={enabledRegionSelection}
								promoCode={promoCode}
								LoginLink={LoginLink}
								searchOptions={searchOptions}
								selectedOption={selectedOption}
								titles={titles}
								onChangePromoCode={this.onChangePromoCode}
								onChangeHotelsRegions={this.onChangeHotelsRegions}
								onChangeCheckinDate={this.onChangeCheckinDate}
								onChangeCheckoutDate={this.onChangeCheckoutDate}
								onNextMonthClick={this.onNextMonthClick}
								onPrevMonthClick={this.onPrevMonthClick}
								onFocusChange={this.onFocusChange}
								lockPromocode={this.state.lockPromocode}
								isMobileView={isMobileView}
							/>
						</div>
					</div>
					<div
						className={classnames(
							css.part,
							css.second,
							"sbox-col-xs-12",
							"sbox-col-sm-6"
						)}
					>
						<div className={css.inside}>
							<PaxPart
								ages={ages}
								showPaxAges={showPaxAges}
								maxNumOfRooms={numRooms}
								direction={direction}
								pax={pax}
								activeRoomNum={activeRoomNum}
								showChildren={showChildren}
								showInfants={showInfants}
								numInfants={numInfants}
								numChildren={numChildren}
								numAdults={numAdults}
								isRounded={isRounded}
								titles={titles}
								onClickAddRoom={this.handleAddRoom}
								onClickRemoveRoom={this.handleRemoveRoom}
								changeActiveRoomNumber={this.changeActiveRoomNumber}
								onPaxAction={this.handlePaxAction}
								onClickSendSubmitSearchBox={this.onClickSendSubmitSearchBox}
								enableSubmit={true}
							/>
						</div>
					</div>
				</div>
			</ElementQuery>
		);
	}
}

SearchBox.propTypes = {
	ages: PropTypes.object,
	showPaxAges: PropTypes.bool,
	calendarOpenDirection: PropTypes.string,
	style: PropTypes.object,
	title: PropTypes.string,
	titles: PropTypes.object,
	titleStyle: PropTypes.object,
	advancedTitle: PropTypes.string,
	direction: PropTypes.oneOf(["left", "right"]),
	isRounded: PropTypes.bool,
	pax: PropTypes.array,
	checkinDate: PropTypes.any,
	checkoutDate: PropTypes.any,
	openAllDates: PropTypes.bool,
	checkinAvailability: PropTypes.object,
	checkoutAvailability: PropTypes.object,
	availabilityLoading: PropTypes.bool,
	focusedInput: PropTypes.string,
	showChildren: PropTypes.bool,
	showInfants: PropTypes.bool,
	numInfants: PropTypes.number,
	numChildren: PropTypes.number,
	numAdults: PropTypes.number,
	searchOptions: PropTypes.array,
	promoCode: PropTypes.string,
	validity: PropTypes.object,
	enabledRegionSelection: PropTypes.bool,
	enableTitle: PropTypes.bool,
	enablePromoCode: PropTypes.bool,
	enableAgentLogin: PropTypes.bool,
	requestHotelsRegions: PropTypes.func,
	requestConfig: PropTypes.func,
	onChangePax: PropTypes.func,
	onChangeHotelsRegions: PropTypes.func,
	onChangePromoCode: PropTypes.func,
	onClickRemoveRoom: PropTypes.func,
	onClickAddRoom: PropTypes.func,
	onChangeActiveRoom: PropTypes.func,
	onChangeCheckinDate: PropTypes.func,
	onChangeCheckoutDate: PropTypes.func,
	onNextMonthClick: PropTypes.func,
	onPrevMonthClick: PropTypes.func,
	onClickOpenCalendar: PropTypes.func,
	onClickSendSubmitSearchBox: PropTypes.func,
	setHotelAvailability: PropTypes.func
};

SearchBox.defaultProps = {
	openAllDates: true,
	style: {},
	numAdults: 3,
	numChildren: 3,
	numInfants: 3,
	numRooms: 3,
	showChildren: true,
	showInfants: true,
	enableTitle: true,
	displayDateFormat: "DD.MM.YYYY",
	pax: [
		{
			Adults: 2,
			Children: 0,
			Infants: 0,
			roomNum: 1
		}
	],
	titles: {
		Adults: "Adults",
		Children: "Children",
		Infants: "Infants",
		Title: "BOOK NOW",
		Advanced: "Advanced",
		Login: "Login",
		PromoCodeTitle: "Promo Code",
		PromoCodePlaceHolder: "Promo Code",
		HotelRegionPlaceHolder: "Choose Region or Hotel",
		SearchButtonText: "Search",
		Room: "Room",
		Of: "Of"
	},
	title: "Title Here",
	titleStyle: {},
	LoginLink: "http://loginLinkMissing.html",
	advancedTitle: "Advanced",
	direction: "left",
	isRounded: false,
	focusedInput: null,
	checkinAvailability: {},
	checkoutAvailability: {},
	availabilityLoading: true,
	searchOptions: [
		{
			label: "All Regions",
			value: "all_regions",
			type: "default"
		},
		{
			label: "North region",
			value: "north",
			type: "region"
		},
		{
			label: "Central region",
			value: "central",
			type: "region"
		},
		{
			label: "East region",
			value: "east",
			type: "region"
		},
		{
			label: "South region",
			value: "south",
			type: "region"
		},
		{
			label: "West region",
			value: "west",
			type: "region"
		}
	],
	promoCode: "",
	requestHotelsRegions: null,
	validity: {},
	activeRoomNum: 1,
	enabledRegionSelection: false,
	enableTitle: false,
	enablePromoCode: false,
	enableAgentLogin: false,
	requestConfig() { },
	onChangePax() { },
	onClickRemoveRoom() { },
	onClickAddRoom() { },
	onChangeActiveRoom() { },
	onChangeCheckinDate() { },
	onChangeCheckoutDate() { },
	onChangeHotelsRegions() { },
	onChangePromoCode() { },
	onNextMonthClick() { },
	onPrevMonthClick() { },
	onClickOpenCalendar() { },
	onClickSendSubmitSearchBox() { },
	setHotelAvailability() { },
	onFocusChange() { }
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/SearchBox/SearchBox.js